import React from 'react'
import createSvgIcon from './../helper'

const fragment = (
  <React.Fragment>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2331 2331"
      id="vector">
      <g
        id="group"
        transform="translate(117 226)">
        <path
          id="path"
          d="M 986.5 0 L 1014 0.5 L 986.5 1 L 986.5 0 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_1"
          d="M 1083.5 0 L 1109 0.5 L 1083.5 1 L 1083.5 0 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_2"
          d="M 953.5 1 L 968 1.5 L 953.5 2 L 953.5 1 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_3"
          d="M 1127.5 1 L 1141 1.5 L 1127.5 2 L 1127.5 1 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_4"
          d="M 929.5 2 L 940 2.5 L 929.5 3 L 929.5 2 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_5"
          d="M 1153.5 2 L 1164 2.5 L 1153.5 3 L 1153.5 2 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_6"
          d="M 909.5 3 L 918 3.5 L 909.5 4 L 909.5 3 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_7"
          d="M 1174.5 3 L 1183 3.5 L 1174.5 4 L 1174.5 3 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_8"
          d="M 892.5 4 L 900 4.5 L 892.5 5 L 892.5 4 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_9"
          d="M 1192.5 4 L 1200 4.5 L 1192.5 5 L 1192.5 4 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_10"
          d="M 876.5 5 L 884 5.5 L 876.5 6 L 876.5 5 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_11"
          d="M 1207.5 5 L 1214 5.5 L 1207.5 6 L 1207.5 5 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_12"
          d="M 862.5 6 L 869 6.5 L 862.5 7 L 862.5 6 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_13"
          d="M 1221.5 6 L 1228 6.5 L 1221.5 7 L 1221.5 6 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_14"
          d="M 849.5 7 L 855 7.5 L 849.5 8 L 849.5 7 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_15"
          d="M 1234.5 7 L 1240 7.5 L 1234.5 8 L 1234.5 7 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_16"
          d="M 837.5 8 L 843 8.5 L 837.5 9 L 837.5 8 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_17"
          d="M 1246.5 8 L 1252 8.5 L 1246.5 9 L 1246.5 8 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_18"
          d="M 826.5 9 L 831 9.5 L 826.5 10 L 826.5 9 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_19"
          d="M 1257.5 9 L 1263 9.5 L 1257.5 10 L 1257.5 9 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_20"
          d="M 815.5 10 L 820 10.5 L 815.5 11 L 815.5 10 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_21"
          d="M 1268.5 10 L 1273 10.5 L 1268.5 11 L 1268.5 10 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_22"
          d="M 805.5 11 L 810 11.5 L 805.5 12 L 805.5 11 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_23"
          d="M 1278.5 11 L 1283 11.5 L 1278.5 12 L 1278.5 11 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_24"
          d="M 795.5 12 L 800 12.5 L 795.5 13 L 795.5 12 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_25"
          d="M 1288.5 12 L 1292 12.5 L 1288.5 13 L 1288.5 12 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_26"
          d="M 786.5 13 L 790 13.5 L 786.5 14 L 786.5 13 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_27"
          d="M 1297.5 13 L 1301 13.5 L 1297.5 14 L 1297.5 13 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_28"
          d="M 777.5 14 L 781 14.5 L 777.5 15 L 777.5 14 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_29"
          d="M 1306.5 14 L 1310 14.5 L 1306.5 15 L 1306.5 14 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_30"
          d="M 768.5 15 L 772 15.5 L 768.5 16 L 768.5 15 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_31"
          d="M 1314.5 15 L 1318 15.5 L 1314.5 16 L 1314.5 15 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_32"
          d="M 760.5 16 L 764 16.5 L 760.5 17 L 760.5 16 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_33"
          d="M 1322.5 16 L 1326 16.5 L 1322.5 17 L 1322.5 16 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_34"
          d="M 751.5 17 L 755 17.5 L 751.5 18 L 751.5 17 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_35"
          d="M 1330.5 17 L 1334 17.5 L 1330.5 18 L 1330.5 17 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_36"
          d="M 744.5 18 L 748 18.5 L 744.5 19 L 744.5 18 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_37"
          d="M 1338.5 18 L 1342 18.5 L 1338.5 19 L 1338.5 18 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_38"
          d="M 736.5 19 L 740 19.5 L 736.5 20 L 736.5 19 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_39"
          d="M 1345.5 19 L 1349 19.5 L 1345.5 20 L 1345.5 19 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_40"
          d="M 729.5 20 L 732 20.5 L 729.5 21 L 729.5 20 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_41"
          d="M 1353.5 20 L 1356 20.5 L 1353.5 21 L 1353.5 20 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_42"
          d="M 722.5 21 L 725 21.5 L 722.5 22 L 722.5 21 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_43"
          d="M 1360.5 21 L 1363 21.5 L 1360.5 22 L 1360.5 21 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_44"
          d="M 715.5 22 L 718 22.5 L 715.5 23 L 715.5 22 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_45"
          d="M 1367.5 22 L 1370 22.5 L 1367.5 23 L 1367.5 22 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_46"
          d="M 708.5 23 L 711 23.5 L 708.5 24 L 708.5 23 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_47"
          d="M 1373.5 23 L 1377 23.5 L 1373.5 24 L 1373.5 23 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_48"
          d="M 701.5 24 L 704 24.5 L 701.5 25 L 701.5 24 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_49"
          d="M 1380.5 24 L 1383 24.5 L 1380.5 25 L 1380.5 24 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_50"
          d="M 695.5 25 L 698 25.5 L 695.5 26 L 695.5 25 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_51"
          d="M 1386.5 25 L 1389 25.5 L 1386.5 26 L 1386.5 25 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_52"
          d="M 688.5 26 L 691 26.5 L 688.5 27 L 688.5 26 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_53"
          d="M 1392.5 26 L 1396 26.5 L 1392.5 27 L 1392.5 26 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_54"
          d="M 682.5 27 L 685 27.5 L 682.5 28 L 682.5 27 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_55"
          d="M 1399.5 27 L 1402 27.5 L 1399.5 28 L 1399.5 27 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_56"
          d="M 676.5 28 L 679 28.5 L 676.5 29 L 676.5 28 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_57"
          d="M 1405.5 28 L 1408 28.5 L 1405.5 29 L 1405.5 28 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_58"
          d="M 670.5 29 L 673 29.5 L 670.5 30 L 670.5 29 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_59"
          d="M 1410.5 29 L 1413 29.5 L 1410.5 30 L 1410.5 29 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_60"
          d="M 664.5 30 L 667 30.5 L 664.5 31 L 664.5 30 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_61"
          d="M 1416.5 30 L 1419 30.5 L 1416.5 31 L 1416.5 30 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_62"
          d="M 658.5 31 L 661 31.5 L 658.5 32 L 658.5 31 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_63"
          d="M 1422.5 31 L 1425 31.5 L 1422.5 32 L 1422.5 31 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_64"
          d="M 1427.5 32 L 1430 32.5 L 1427.5 33 L 1427.5 32 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_65"
          d="M 647.5 33 L 650 33.5 L 647.5 34 L 647.5 33 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_66"
          d="M 1433.5 33 L 1436 33.5 L 1433.5 34 L 1433.5 33 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_67"
          d="M 1438.5 34 L 1441 34.5 L 1438.5 35 L 1438.5 34 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_68"
          d="M 636.5 35 L 639 35.5 L 636.5 36 L 636.5 35 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_69"
          d="M 631.5 36 L 634 36.5 L 631.5 37 L 631.5 36 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_70"
          d="M 1478.5 42 L 1481 42.5 L 1478.5 43 L 1478.5 42 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_71"
          d="M 596.5 43 L 599 43.5 L 596.5 44 L 596.5 43 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_72"
          d="M 1505.5 48 L 1508 48.5 L 1505.5 49 L 1505.5 48 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_73"
          d="M 556.5 52 L 559 52.5 L 556.5 53 L 556.5 52 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_74"
          d="M 267.5 156 L 266.5 158 L 267.5 156 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_75"
          d="M 250.5 165 L 249.5 167 L 250.5 165 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_76"
          d="M 239.5 171 L 238.5 173 L 239.5 171 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_77"
          d="M 1850.5 173 L 1851.5 175 L 1850.5 173 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_78"
          d="M 225.5 179 L 224.5 181 L 225.5 179 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_79"
          d="M 1863.5 180 L 1864.5 182 L 1863.5 180 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_80"
          d="M 1872.5 185 L 1873.5 187 L 1872.5 185 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_81"
          d="M 1886.5 193 L 1887.5 195 L 1886.5 193 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_82"
          d="M 200.5 194 L 199.5 196 L 200.5 194 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_83"
          d="M 192.5 199 L 191.5 201 L 192.5 199 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_84"
          d="M 1898.5 200 L 1899.5 202 L 1898.5 200 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_85"
          d="M 189.5 201 L 188.5 203 L 189.5 201 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_86"
          d="M 1903.5 203 L 1904.5 205 L 1903.5 203 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_87"
          d="M 1916.5 211 L 1917.5 213 L 1916.5 211 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_88"
          d="M 168.5 215 L 167.5 217 L 168.5 215 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_89"
          d="M 1924.5 216 L 1925.5 218 L 1924.5 216 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_90"
          d="M 165.5 217 L 164.5 219 L 165.5 217 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_91"
          d="M 1927.5 218 L 1928.5 220 L 1927.5 218 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_92"
          d="M 162.5 219 L 161.5 221 L 162.5 219 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_93"
          d="M 158.5 222 L 157.5 224 L 158.5 222 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_94"
          d="M 155.5 224 L 154.5 226 L 155.5 224 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_95"
          d="M 151.5 227 L 150.5 229 L 151.5 227 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_96"
          d="M 1941.5 227 L 1942.5 229 L 1941.5 227 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_97"
          d="M 148.5 229 L 147.5 231 L 148.5 229 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_98"
          d="M 1944.5 229 L 1945.5 231 L 1944.5 229 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_99"
          d="M 1947.5 231 L 1948.5 233 L 1947.5 231 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_100"
          d="M 144.5 232 L 143.5 234 L 144.5 232 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_101"
          d="M 140.5 235 L 139.5 237 L 140.5 235 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_102"
          d="M 136.5 238 L 135.5 240 L 136.5 238 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_103"
          d="M 1960.5 240 L 1961.5 242 L 1960.5 240 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_104"
          d="M 132.5 241 L 130.5 244 L 132.5 241 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_105"
          d="M 1963.5 242 L 1964.5 244 L 1963.5 242 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_106"
          d="M 127.5 245 L 126.5 247 L 127.5 245 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_107"
          d="M 1970.5 247 L 1971.5 249 L 1970.5 247 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_108"
          d="M 123.5 248 L 121.5 251 L 123.5 248 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_109"
          d="M 118.5 252 L 115.5 256 L 118.5 252 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_110"
          d="M 1977.5 252 L 1978.5 254 L 1977.5 252 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_111"
          d="M 1981.5 255 L 1982.5 257 L 1981.5 255 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_112"
          d="M 112.5 257 L 109.5 261 L 112.5 257 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_113"
          d="M 1985.5 258 L 1986.5 260 L 1985.5 258 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_114"
          d="M 1989.5 261 L 1991.5 264 L 1989.5 261 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_115"
          d="M 105.5 263 L 100.5 269 L 105.5 263 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_116"
          d="M 1994.5 265 L 1997.5 269 L 1994.5 265 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_117"
          d="M 2000.5 270 L 2005.5 276 L 2000.5 270 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_118"
          d="M 95.5 272 L 79.5 289 L 95.5 272 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_119"
          d="M 2010.5 279 L 2023.5 293 L 2010.5 279 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_120"
          d="M 75.5 293 L 71.5 298 L 75.5 293 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_121"
          d="M 2027.5 297 L 2031.5 302 L 2027.5 297 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_122"
          d="M 68.5 301 L 65.5 305 L 68.5 301 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_123"
          d="M 2033.5 304 L 2036.5 308 L 2033.5 304 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_124"
          d="M 63.5 307 L 61.5 310 L 63.5 307 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_125"
          d="M 2038.5 310 L 2040.5 313 L 2038.5 310 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_126"
          d="M 59.5 312 L 58.5 314 L 59.5 312 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_127"
          d="M 2041.5 314 L 2043.5 317 L 2041.5 314 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_128"
          d="M 56.5 316 L 55.5 318 L 56.5 316 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_129"
          d="M 2044.5 318 L 2045.5 320 L 2044.5 318 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_130"
          d="M 53.5 320 L 52.5 322 L 53.5 320 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_131"
          d="M 1022.5 320 L 1082 320.5 L 1022.5 321 L 1022.5 320 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_132"
          d="M 986.5 321 L 1001 321.5 L 986.5 322 L 986.5 321 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_133"
          d="M 1102.5 321 L 1116 321.5 L 1102.5 322 L 1102.5 321 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_134"
          d="M 964.5 322 L 974 322.5 L 964.5 323 L 964.5 322 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_135"
          d="M 1127.5 322 L 1137 322.5 L 1127.5 323 L 1127.5 322 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_136"
          d="M 946.5 323 L 954 323.5 L 946.5 324 L 946.5 323 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_137"
          d="M 1146.5 323 L 1155 323.5 L 1146.5 324 L 1146.5 323 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_138"
          d="M 930.5 324 L 938 324.5 L 930.5 325 L 930.5 324 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_139"
          d="M 1162.5 324 L 1170 324.5 L 1162.5 325 L 1162.5 324 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_140"
          d="M 917.5 325 L 923 325.5 L 917.5 326 L 917.5 325 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_141"
          d="M 1176.5 325 L 1183 325.5 L 1176.5 326 L 1176.5 325 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_142"
          d="M 2049.5 325 L 2050.5 327 L 2049.5 325 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_143"
          d="M 904.5 326 L 910 326.5 L 904.5 327 L 904.5 326 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_144"
          d="M 1189.5 326 L 1195 326.5 L 1189.5 327 L 1189.5 326 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_145"
          d="M 892.5 327 L 898 327.5 L 892.5 328 L 892.5 327 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_146"
          d="M 1201.5 327 L 1207 327.5 L 1201.5 328 L 1201.5 327 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_147"
          d="M 882.5 328 L 887 328.5 L 882.5 329 L 882.5 328 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_148"
          d="M 1212.5 328 L 1217 328.5 L 1212.5 329 L 1212.5 328 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_149"
          d="M 2051.5 328 L 2052.5 330 L 2051.5 328 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_150"
          d="M 871.5 329 L 876 329.5 L 871.5 330 L 871.5 329 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_151"
          d="M 1223.5 329 L 1227 329.5 L 1223.5 330 L 1223.5 329 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_152"
          d="M 862.5 330 L 867 330.5 L 862.5 331 L 862.5 330 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_153"
          d="M 1232.5 330 L 1237 330.5 L 1232.5 331 L 1232.5 330 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_154"
          d="M 853.5 331 L 857 331.5 L 853.5 332 L 853.5 331 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_155"
          d="M 1242.5 331 L 1246 331.5 L 1242.5 332 L 1242.5 331 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_156"
          d="M 844.5 332 L 848 332.5 L 844.5 333 L 844.5 332 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_157"
          d="M 1250.5 332 L 1255 332.5 L 1250.5 333 L 1250.5 332 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_158"
          d="M 835.5 333 L 840 333.5 L 835.5 334 L 835.5 333 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_159"
          d="M 1259.5 333 L 1263 333.5 L 1259.5 334 L 1259.5 333 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_160"
          d="M 827.5 334 L 831 334.5 L 827.5 335 L 827.5 334 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_161"
          d="M 1267.5 334 L 1271 334.5 L 1267.5 335 L 1267.5 334 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_162"
          d="M 819.5 335 L 823 335.5 L 819.5 336 L 819.5 335 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_163"
          d="M 1275.5 335 L 1279 335.5 L 1275.5 336 L 1275.5 335 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_164"
          d="M 812.5 336 L 816 336.5 L 812.5 337 L 812.5 336 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_165"
          d="M 1282.5 336 L 1286 336.5 L 1282.5 337 L 1282.5 336 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_166"
          d="M 805.5 337 L 808 337.5 L 805.5 338 L 805.5 337 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_167"
          d="M 1290.5 337 L 1293 337.5 L 1290.5 338 L 1290.5 337 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_168"
          d="M 41.5 338 L 40.5 340 L 41.5 338 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_169"
          d="M 798.5 338 L 801 338.5 L 798.5 339 L 798.5 338 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_170"
          d="M 1297.5 338 L 1300 338.5 L 1297.5 339 L 1297.5 338 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_171"
          d="M 791.5 339 L 794 339.5 L 791.5 340 L 791.5 339 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_172"
          d="M 1304.5 339 L 1307 339.5 L 1304.5 340 L 1304.5 339 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_173"
          d="M 784.5 340 L 787 340.5 L 784.5 341 L 784.5 340 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_174"
          d="M 1311.5 340 L 1314 340.5 L 1311.5 341 L 1311.5 340 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_175"
          d="M 778.5 341 L 781 341.5 L 778.5 342 L 778.5 341 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_176"
          d="M 1317.5 341 L 1320 341.5 L 1317.5 342 L 1317.5 341 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_177"
          d="M 771.5 342 L 774 342.5 L 771.5 343 L 771.5 342 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_178"
          d="M 1323.5 342 L 1327 342.5 L 1323.5 343 L 1323.5 342 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_179"
          d="M 38.5 343 L 37.5 345 L 38.5 343 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_180"
          d="M 765.5 343 L 768 343.5 L 765.5 344 L 765.5 343 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_181"
          d="M 1330.5 343 L 1333 343.5 L 1330.5 344 L 1330.5 343 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_182"
          d="M 2060.5 343 L 2061.5 345 L 2060.5 343 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_183"
          d="M 759.5 344 L 762 344.5 L 759.5 345 L 759.5 344 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_184"
          d="M 1336.5 344 L 1339 344.5 L 1336.5 345 L 1336.5 344 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_185"
          d="M 753.5 345 L 756 345.5 L 753.5 346 L 753.5 345 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_186"
          d="M 747.5 346 L 750 346.5 L 747.5 347 L 747.5 346 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_187"
          d="M 1347.5 346 L 1350 346.5 L 1347.5 347 L 1347.5 346 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_188"
          d="M 1353.5 347 L 1356 347.5 L 1353.5 348 L 1353.5 347 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_189"
          d="M 736.5 348 L 739 348.5 L 736.5 349 L 736.5 348 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_190"
          d="M 1364.5 349 L 1367 349.5 L 1364.5 350 L 1364.5 349 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_191"
          d="M 34.5 350 L 33.5 352 L 34.5 350 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_192"
          d="M 725.5 350 L 728 350.5 L 725.5 351 L 725.5 350 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_193"
          d="M 1369.5 350 L 1372 350.5 L 1369.5 351 L 1369.5 350 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_194"
          d="M 720.5 351 L 723 351.5 L 720.5 352 L 720.5 351 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_195"
          d="M 715.5 352 L 718 352.5 L 715.5 353 L 715.5 352 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_196"
          d="M 710.5 353 L 713 353.5 L 710.5 354 L 710.5 353 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_197"
          d="M 705.5 354 L 708 354.5 L 705.5 355 L 705.5 354 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_198"
          d="M 700.5 355 L 703 355.5 L 700.5 356 L 700.5 355 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_199"
          d="M 1394.5 355 L 1397 355.5 L 1394.5 356 L 1394.5 355 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_200"
          d="M 1399.5 356 L 1402 356.5 L 1399.5 357 L 1399.5 356 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_201"
          d="M 686.5 358 L 689 358.5 L 686.5 359 L 686.5 358 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_202"
          d="M 852.5 409 L 853 679.5 L 852 679.5 L 852.5 409 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_203"
          d="M 1227.5 409 L 1228 670.5 L 1227 670.5 L 1227.5 409 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_204"
          d="M 2088.5 421 L 2089 423.5 L 2088 423.5 L 2088.5 421 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_205"
          d="M 6.5 423 L 7 425.5 L 6 425.5 L 6.5 423 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_206"
          d="M 2089.5 427 L 2090 429.5 L 2089 429.5 L 2089.5 427 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_207"
          d="M 5.5 428 L 6 430.5 L 5 430.5 L 5.5 428 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_208"
          d="M 4.5 433 L 5 435.5 L 4 435.5 L 4.5 433 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_209"
          d="M 2090.5 434 L 2091 437.5 L 2090 437.5 L 2090.5 434 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_210"
          d="M 3.5 439 L 4 441.5 L 3 441.5 L 3.5 439 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_211"
          d="M 2091.5 443 L 2092 447.5 L 2091 447.5 L 2091.5 443 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_212"
          d="M 2.5 446 L 3 449.5 L 2 449.5 L 2.5 446 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_213"
          d="M 1.5 454 L 2 458.5 L 1 458.5 L 1.5 454 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_214"
          d="M 2092.5 456 L 2093 488.5 L 2092 488.5 L 2092.5 456 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_215"
          d="M 0.5 466 L 1 477.5 L 0 477.5 L 0.5 466 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_216"
          d="M 0.5 493 L 1 504.5 L 0 504.5 L 0.5 493 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_217"
          d="M 2091.5 497 L 2092 502.5 L 2091 502.5 L 2091.5 497 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_218"
          d="M 2090.5 508 L 2091 512.5 L 2090 512.5 L 2090.5 508 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_219"
          d="M 1.5 512 L 2 516.5 L 1 516.5 L 1.5 512 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_220"
          d="M 2089.5 517 L 2090 519.5 L 2089 519.5 L 2089.5 517 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_221"
          d="M 2.5 522 L 3 525.5 L 2 525.5 L 2.5 522 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_222"
          d="M 2088.5 524 L 2089 526.5 L 2088 526.5 L 2088.5 524 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_223"
          d="M 3.5 530 L 4 533.5 L 3 533.5 L 3.5 530 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_224"
          d="M 2087.5 530 L 2088 532.5 L 2087 532.5 L 2087.5 530 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_225"
          d="M 2086.5 536 L 2087 538.5 L 2086 538.5 L 2086.5 536 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_226"
          d="M 4.5 537 L 5 539.5 L 4 539.5 L 4.5 537 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_227"
          d="M 2085.5 541 L 2086 543.5 L 2085 543.5 L 2085.5 541 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_228"
          d="M 5.5 543 L 6 545.5 L 5 545.5 L 5.5 543 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_229"
          d="M 2084.5 546 L 2085 548.5 L 2084 548.5 L 2084.5 546 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_230"
          d="M 8.5 558 L 9 560.5 L 8 560.5 L 8.5 558 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_231"
          d="M 444.5 580 L 442.5 583 L 444.5 580 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_232"
          d="M 1652.5 582 L 1654.5 585 L 1652.5 582 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_233"
          d="M 1656.5 587 L 1659.5 591 L 1656.5 587 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_234"
          d="M 1661.5 593 L 1665.5 598 L 1661.5 593 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_235"
          d="M 428.5 596 L 415.5 610 L 428.5 596 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_236"
          d="M 1668.5 601 L 1675.5 609 L 1668.5 601 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_237"
          d="M 1470.5 605 L 1471 607.5 L 1470 607.5 L 1470.5 605 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_238"
          d="M 410.5 613 L 404.5 620 L 410.5 613 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_239"
          d="M 1680.5 614 L 1697.5 632 L 1680.5 614 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_240"
          d="M 400.5 622 L 396.5 627 L 400.5 622 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_241"
          d="M 1474.5 622 L 1475 624.5 L 1474 624.5 L 1474.5 622 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_242"
          d="M 392.5 629 L 389.5 633 L 392.5 629 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_243"
          d="M 1476.5 631 L 1477 633.5 L 1476 633.5 L 1476.5 631 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_244"
          d="M 385.5 635 L 383.5 638 L 385.5 635 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_245"
          d="M 1703.5 636 L 1710.5 644 L 1703.5 636 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_246"
          d="M 601.5 638 L 602 640.5 L 601 640.5 L 601.5 638 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_247"
          d="M 379.5 640 L 377.5 643 L 379.5 640 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_248"
          d="M 374.5 644 L 372.5 647 L 374.5 644 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_249"
          d="M 1479.5 645 L 1480 647.5 L 1479 647.5 L 1479.5 645 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_250"
          d="M 1713.5 645 L 1717.5 650 L 1713.5 645 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_251"
          d="M 369.5 648 L 367.5 651 L 369.5 648 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_252"
          d="M 1480.5 650 L 1481 652.5 L 1480 652.5 L 1480.5 650 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_253"
          d="M 364.5 652 L 363.5 654 L 364.5 652 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_254"
          d="M 1721.5 652 L 1724.5 656 L 1721.5 652 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_255"
          d="M 360.5 655 L 358.5 658 L 360.5 655 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_256"
          d="M 1481.5 655 L 1482 657.5 L 1481 657.5 L 1481.5 655 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_257"
          d="M 1727.5 657 L 1729.5 660 L 1727.5 657 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_258"
          d="M 355.5 659 L 354.5 661 L 355.5 659 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_259"
          d="M 1482.5 660 L 1483 662.5 L 1482 662.5 L 1482.5 660 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_260"
          d="M 1732.5 661 L 1734.5 664 L 1732.5 661 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_261"
          d="M 351.5 662 L 350.5 664 L 351.5 662 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_262"
          d="M 348.5 664 L 346.5 667 L 348.5 664 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_263"
          d="M 1483.5 665 L 1484 667.5 L 1483 667.5 L 1483.5 665 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_264"
          d="M 1737.5 665 L 1739.5 668 L 1737.5 665 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_265"
          d="M 344.5 667 L 343.5 669 L 344.5 667 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_266"
          d="M 1741.5 668 L 1743.5 671 L 1741.5 668 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_267"
          d="M 340.5 670 L 339.5 672 L 340.5 670 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_268"
          d="M 337.5 672 L 336.5 674 L 337.5 672 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_269"
          d="M 1746.5 672 L 1747.5 674 L 1746.5 672 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_270"
          d="M 594.5 673 L 595 675.5 L 594 675.5 L 594.5 673 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_271"
          d="M 1749.5 674 L 1751.5 677 L 1749.5 674 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_272"
          d="M 333.5 675 L 332.5 677 L 333.5 675 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_273"
          d="M 330.5 677 L 329.5 679 L 330.5 677 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_274"
          d="M 1753.5 677 L 1754.5 679 L 1753.5 677 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_275"
          d="M 593.5 678 L 594 680.5 L 593 680.5 L 593.5 678 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_276"
          d="M 327.5 679 L 326.5 681 L 327.5 679 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_277"
          d="M 1757.5 680 L 1758.5 682 L 1757.5 680 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_278"
          d="M 1760.5 682 L 1761.5 684 L 1760.5 682 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_279"
          d="M 1763.5 684 L 1764.5 686 L 1763.5 684 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_280"
          d="M 1227.5 685 L 1228 689.5 L 1227 689.5 L 1227.5 685 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_281"
          d="M 1487.5 685 L 1488 687.5 L 1487 687.5 L 1487.5 685 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_282"
          d="M 853.5 686 L 854 690.5 L 853 690.5 L 853.5 686 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_283"
          d="M 309.5 691 L 308.5 693 L 309.5 691 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_284"
          d="M 306.5 693 L 305.5 695 L 306.5 693 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_285"
          d="M 854.5 694 L 855 696.5 L 854 696.5 L 854.5 694 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_286"
          d="M 1226.5 694 L 1227 696.5 L 1226 696.5 L 1226.5 694 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_287"
          d="M 1778.5 694 L 1779.5 696 L 1778.5 694 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_288"
          d="M 61.5 695 L 62.5 697 L 61.5 695 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_289"
          d="M 1781.5 696 L 1782.5 698 L 1781.5 696 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_290"
          d="M 2028.5 697 L 2027.5 699 L 2028.5 697 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_291"
          d="M 298.5 698 L 297.5 700 L 298.5 698 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_292"
          d="M 2022.5 708 L 2021.5 710 L 2022.5 708 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_293"
          d="M 1817.5 717 L 1818.5 719 L 1817.5 717 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_294"
          d="M 264.5 718 L 263.5 720 L 264.5 718 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_295"
          d="M 77.5 722 L 78.5 724 L 77.5 722 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_296"
          d="M 1212.5 732 L 1211.5 734 L 1212.5 732 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_297"
          d="M 84.5 733 L 85.5 735 L 84.5 733 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_298"
          d="M 868.5 734 L 869.5 736 L 868.5 734 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_299"
          d="M 1210.5 735 L 1209.5 737 L 1210.5 735 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_300"
          d="M 86.5 736 L 87.5 738 L 86.5 736 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_301"
          d="M 870.5 737 L 871.5 739 L 870.5 737 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_302"
          d="M 1208.5 738 L 1207.5 740 L 1208.5 738 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_303"
          d="M 88.5 739 L 89.5 741 L 88.5 739 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_304"
          d="M 872.5 740 L 874.5 743 L 872.5 740 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_305"
          d="M 90.5 742 L 91.5 744 L 90.5 742 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_306"
          d="M 1205.5 742 L 1202.5 746 L 1205.5 742 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_307"
          d="M 2002.5 742 L 2001.5 744 L 2002.5 742 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_308"
          d="M 876.5 745 L 887.5 757 L 876.5 745 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_309"
          d="M 2000.5 745 L 1999.5 747 L 2000.5 745 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_310"
          d="M 95.5 749 L 96.5 751 L 95.5 749 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_311"
          d="M 567.5 749 L 566.5 751 L 567.5 749 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_312"
          d="M 1511.5 749 L 1512.5 751 L 1511.5 749 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_313"
          d="M 97.5 752 L 98.5 754 L 97.5 752 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_314"
          d="M 565.5 752 L 563.5 755 L 565.5 752 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_315"
          d="M 1513.5 752 L 1515.5 755 L 1513.5 752 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_316"
          d="M 1192.5 755 L 1189.5 759 L 1192.5 755 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_317"
          d="M 100.5 756 L 101.5 758 L 100.5 756 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_318"
          d="M 1993.5 756 L 1992.5 758 L 1993.5 756 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_319"
          d="M 561.5 757 L 546.5 773 L 561.5 757 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_320"
          d="M 1517.5 757 L 1520.5 761 L 1517.5 757 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_321"
          d="M 890.5 758 L 892.5 761 L 890.5 758 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_322"
          d="M 102.5 759 L 103.5 761 L 102.5 759 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_323"
          d="M 1991.5 759 L 1990.5 761 L 1991.5 759 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_324"
          d="M 1186.5 760 L 1185.5 762 L 1186.5 760 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_325"
          d="M 894.5 761 L 895.5 763 L 894.5 761 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_326"
          d="M 1183.5 762 L 1182.5 764 L 1183.5 762 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_327"
          d="M 1989.5 762 L 1988.5 764 L 1989.5 762 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_328"
          d="M 105.5 763 L 106.5 765 L 105.5 763 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_329"
          d="M 1180.5 764 L 1179.5 766 L 1180.5 764 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_330"
          d="M 900.5 765 L 901.5 767 L 900.5 765 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_331"
          d="M 108.5 767 L 109.5 769 L 108.5 767 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_332"
          d="M 1175.5 767 L 1174.5 769 L 1175.5 767 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_333"
          d="M 1984.5 769 L 1983.5 771 L 1984.5 769 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_334"
          d="M 1530.5 770 L 1534.5 775 L 1530.5 770 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_335"
          d="M 111.5 771 L 113.5 774 L 111.5 771 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_336"
          d="M 1982.5 772 L 1981.5 774 L 1982.5 772 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_337"
          d="M 543.5 774 L 540.5 778 L 543.5 774 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_338"
          d="M 115.5 776 L 117.5 779 L 115.5 776 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_339"
          d="M 1537.5 776 L 1539.5 779 L 1537.5 776 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_340"
          d="M 1979.5 776 L 1978.5 778 L 1979.5 776 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_341"
          d="M 537.5 779 L 536.5 781 L 537.5 779 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_342"
          d="M 1542.5 780 L 1544.5 783 L 1542.5 780 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_343"
          d="M 533.5 782 L 531.5 785 L 533.5 782 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_344"
          d="M 948.5 784 L 951 784.5 L 948.5 785 L 948.5 784 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_345"
          d="M 1547.5 784 L 1548.5 786 L 1547.5 784 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_346"
          d="M 529.5 785 L 528.5 787 L 529.5 785 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_347"
          d="M 963.5 787 L 966 787.5 L 963.5 788 L 963.5 787 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_348"
          d="M 1551.5 787 L 1552.5 789 L 1551.5 787 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_349"
          d="M 525.5 788 L 524.5 790 L 525.5 788 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_350"
          d="M 970.5 788 L 973 788.5 L 970.5 789 L 970.5 788 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_351"
          d="M 977.5 789 L 981 789.5 L 977.5 790 L 977.5 789 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_352"
          d="M 1101.5 789 L 1105 789.5 L 1101.5 790 L 1101.5 789 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_353"
          d="M 1554.5 789 L 1555.5 791 L 1554.5 789 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_354"
          d="M 986.5 790 L 991 790.5 L 986.5 791 L 986.5 790 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_355"
          d="M 1094.5 790 L 1098 790.5 L 1094.5 791 L 1094.5 790 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_356"
          d="M 521.5 791 L 520.5 793 L 521.5 791 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_357"
          d="M 998.5 791 L 1006 791.5 L 998.5 792 L 998.5 791 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_358"
          d="M 1086.5 791 L 1090 791.5 L 1086.5 792 L 1086.5 791 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_359"
          d="M 1017.5 792 L 1042 792.5 L 1017.5 793 L 1017.5 792 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_360"
          d="M 1072.5 792 L 1080 792.5 L 1072.5 793 L 1072.5 792 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_361"
          d="M 1558.5 792 L 1559.5 794 L 1558.5 792 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_362"
          d="M 518.5 793 L 517.5 795 L 518.5 793 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_363"
          d="M 1561.5 794 L 1562.5 796 L 1561.5 794 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_364"
          d="M 514.5 796 L 513.5 798 L 514.5 796 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_365"
          d="M 511.5 798 L 510.5 800 L 511.5 798 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_366"
          d="M 1568.5 799 L 1569.5 801 L 1568.5 799 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_367"
          d="M 507.5 801 L 506.5 803 L 507.5 801 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_368"
          d="M 1571.5 801 L 1572.5 803 L 1571.5 801 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_369"
          d="M 504.5 803 L 503.5 805 L 504.5 803 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_370"
          d="M 500.5 806 L 499.5 808 L 500.5 806 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_371"
          d="M 1578.5 806 L 1579.5 808 L 1578.5 806 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_372"
          d="M 497.5 808 L 496.5 810 L 497.5 808 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_373"
          d="M 1581.5 808 L 1582.5 810 L 1581.5 808 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_374"
          d="M 493.5 811 L 492.5 813 L 493.5 811 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_375"
          d="M 490.5 813 L 489.5 815 L 490.5 813 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_376"
          d="M 1588.5 813 L 1589.5 815 L 1588.5 813 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_377"
          d="M 1591.5 815 L 1592.5 817 L 1591.5 815 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_378"
          d="M 486.5 816 L 485.5 818 L 486.5 816 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_379"
          d="M 483.5 818 L 482.5 820 L 483.5 818 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_380"
          d="M 480.5 820 L 479.5 822 L 480.5 820 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_381"
          d="M 1598.5 820 L 1599.5 822 L 1598.5 820 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_382"
          d="M 1601.5 822 L 1602.5 824 L 1601.5 822 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_383"
          d="M 473.5 825 L 472.5 827 L 473.5 825 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_384"
          d="M 470.5 827 L 469.5 829 L 470.5 827 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_385"
          d="M 1608.5 827 L 1609.5 829 L 1608.5 827 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_386"
          d="M 1611.5 829 L 1612.5 831 L 1611.5 829 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_387"
          d="M 463.5 832 L 462.5 834 L 463.5 832 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_388"
          d="M 460.5 834 L 459.5 836 L 460.5 834 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_389"
          d="M 1618.5 834 L 1619.5 836 L 1618.5 834 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_390"
          d="M 457.5 836 L 456.5 838 L 457.5 836 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_391"
          d="M 1621.5 836 L 1622.5 838 L 1621.5 836 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_392"
          d="M 450.5 841 L 449.5 843 L 450.5 841 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_393"
          d="M 1628.5 841 L 1629.5 843 L 1628.5 841 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_394"
          d="M 446.5 844 L 445.5 846 L 446.5 844 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_395"
          d="M 1632.5 844 L 1633.5 846 L 1632.5 844 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_396"
          d="M 443.5 846 L 441.5 849 L 443.5 846 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_397"
          d="M 1635.5 846 L 1637.5 849 L 1635.5 846 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_398"
          d="M 1639.5 849 L 1641.5 852 L 1639.5 849 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_399"
          d="M 438.5 850 L 437.5 852 L 438.5 850 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_400"
          d="M 434.5 853 L 431.5 857 L 434.5 853 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_401"
          d="M 1644.5 853 L 1646.5 856 L 1644.5 853 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_402"
          d="M 1649.5 857 L 1652.5 861 L 1649.5 857 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_403"
          d="M 428.5 858 L 425.5 862 L 428.5 858 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_404"
          d="M 1655.5 862 L 1659.5 867 L 1655.5 862 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_405"
          d="M 421.5 864 L 416.5 870 L 421.5 864 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_406"
          d="M 1663.5 869 L 1673.5 880 L 1663.5 869 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_407"
          d="M 412.5 872 L 392.5 893 L 412.5 872 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_408"
          d="M 1681.5 887 L 1692.5 899 L 1681.5 887 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_409"
          d="M 388.5 897 L 383.5 903 L 388.5 897 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_410"
          d="M 1695.5 902 L 1699.5 907 L 1695.5 902 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_411"
          d="M 380.5 906 L 377.5 910 L 380.5 906 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_412"
          d="M 1702.5 910 L 1705.5 914 L 1702.5 910 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_413"
          d="M 374.5 913 L 372.5 916 L 374.5 913 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_414"
          d="M 1707.5 916 L 1709.5 919 L 1707.5 916 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_415"
          d="M 370.5 918 L 368.5 921 L 370.5 918 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_416"
          d="M 1711.5 921 L 1713.5 924 L 1711.5 921 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_417"
          d="M 366.5 923 L 364.5 926 L 366.5 923 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_418"
          d="M 1715.5 926 L 1716.5 928 L 1715.5 926 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_419"
          d="M 363.5 927 L 361.5 930 L 363.5 927 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_420"
          d="M 1718.5 930 L 1719.5 932 L 1718.5 930 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_421"
          d="M 360.5 931 L 358.5 934 L 360.5 931 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_422"
          d="M 1721.5 934 L 1722.5 936 L 1721.5 934 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_423"
          d="M 357.5 935 L 356.5 937 L 357.5 935 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_424"
          d="M 1723.5 937 L 1724.5 939 L 1723.5 937 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_425"
          d="M 354.5 939 L 353.5 941 L 354.5 939 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_426"
          d="M 1726.5 941 L 1727.5 943 L 1726.5 941 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_427"
          d="M 352.5 942 L 351.5 944 L 352.5 942 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_428"
          d="M 1728.5 944 L 1729.5 946 L 1728.5 944 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_429"
          d="M 1013.5 945 L 1022 945.5 L 1013.5 946 L 1013.5 945 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_430"
          d="M 1058.5 945 L 1067 945.5 L 1058.5 946 L 1058.5 945 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_431"
          d="M 1000.5 946 L 1006 946.5 L 1000.5 947 L 1000.5 946 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_432"
          d="M 1074.5 946 L 1079 946.5 L 1074.5 947 L 1074.5 946 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_433"
          d="M 991.5 947 L 995 947.5 L 991.5 948 L 991.5 947 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_434"
          d="M 1084.5 947 L 1088 947.5 L 1084.5 948 L 1084.5 947 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_435"
          d="M 983.5 948 L 987 948.5 L 983.5 949 L 983.5 948 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_436"
          d="M 1092.5 948 L 1096 948.5 L 1092.5 949 L 1092.5 948 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_437"
          d="M 977.5 949 L 980 949.5 L 977.5 950 L 977.5 949 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_438"
          d="M 1100.5 949 L 1103 949.5 L 1100.5 950 L 1100.5 949 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_439"
          d="M 970.5 950 L 973 950.5 L 970.5 951 L 970.5 950 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_440"
          d="M 1106.5 950 L 1109 950.5 L 1106.5 951 L 1106.5 950 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_441"
          d="M 965.5 951 L 968 951.5 L 965.5 952 L 965.5 951 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_442"
          d="M 1112.5 951 L 1115 951.5 L 1112.5 952 L 1112.5 951 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_443"
          d="M 1117.5 952 L 1120 952.5 L 1117.5 953 L 1117.5 952 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_444"
          d="M 1122.5 953 L 1125 953.5 L 1122.5 954 L 1122.5 953 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_445"
          d="M 941.5 956 L 944 956.5 L 941.5 957 L 941.5 956 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_446"
          d="M 340.5 960 L 339.5 962 L 340.5 960 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_447"
          d="M 1740.5 962 L 1741.5 964 L 1740.5 962 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_448"
          d="M 338.5 963 L 337.5 965 L 338.5 963 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_449"
          d="M 329.5 978 L 328.5 980 L 329.5 978 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_450"
          d="M 1752.5 982 L 1753.5 984 L 1752.5 982 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_451"
          d="M 325.5 985 L 324.5 987 L 325.5 985 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_452"
          d="M 1757.5 991 L 1758.5 993 L 1757.5 991 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_453"
          d="M 319.5 996 L 318.5 998 L 319.5 996 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_454"
          d="M 1250.5 1002 L 1251.5 1004 L 1250.5 1002 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_455"
          d="M 1255.5 1005 L 1256.5 1007 L 1255.5 1005 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_456"
          d="M 817.5 1009 L 816.5 1011 L 817.5 1009 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_457"
          d="M 1263.5 1010 L 1264.5 1012 L 1263.5 1010 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_458"
          d="M 814.5 1011 L 813.5 1013 L 814.5 1011 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_459"
          d="M 1266.5 1012 L 1267.5 1014 L 1266.5 1012 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_460"
          d="M 811.5 1013 L 810.5 1015 L 811.5 1013 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_461"
          d="M 1269.5 1014 L 1270.5 1016 L 1269.5 1014 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_462"
          d="M 808.5 1015 L 807.5 1017 L 808.5 1015 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_463"
          d="M 1272.5 1016 L 1273.5 1018 L 1272.5 1016 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_464"
          d="M 805.5 1017 L 804.5 1019 L 805.5 1017 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_465"
          d="M 1275.5 1018 L 1276.5 1020 L 1275.5 1018 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_466"
          d="M 802.5 1019 L 801.5 1021 L 802.5 1019 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_467"
          d="M 798.5 1022 L 797.5 1024 L 798.5 1022 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_468"
          d="M 1282.5 1023 L 1283.5 1025 L 1282.5 1023 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_469"
          d="M 795.5 1024 L 793.5 1027 L 795.5 1024 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_470"
          d="M 1286.5 1026 L 1287.5 1028 L 1286.5 1026 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_471"
          d="M 791.5 1027 L 789.5 1030 L 791.5 1027 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_472"
          d="M 1290.5 1029 L 1291.5 1031 L 1290.5 1029 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_473"
          d="M 787.5 1030 L 785.5 1033 L 787.5 1030 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_474"
          d="M 1294.5 1032 L 1296.5 1035 L 1294.5 1032 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_475"
          d="M 782.5 1034 L 780.5 1037 L 782.5 1034 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_476"
          d="M 1299.5 1036 L 1301.5 1039 L 1299.5 1036 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_477"
          d="M 777.5 1038 L 774.5 1042 L 777.5 1038 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_478"
          d="M 1304.5 1040 L 1307.5 1044 L 1304.5 1040 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_479"
          d="M 1030.5 1041 L 1034 1041.5 L 1030.5 1042 L 1030.5 1041 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_480"
          d="M 1046.5 1041 L 1050 1041.5 L 1046.5 1042 L 1046.5 1041 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_481"
          d="M 771.5 1043 L 767.5 1048 L 771.5 1043 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_482"
          d="M 1311.5 1046 L 1316.5 1052 L 1311.5 1046 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_483"
          d="M 764.5 1049 L 756.5 1058 L 764.5 1049 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_484"
          d="M 1005.5 1050 L 1004.5 1052 L 1005.5 1050 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_485"
          d="M 1075.5 1051 L 1076.5 1053 L 1075.5 1051 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_486"
          d="M 1002.5 1052 L 1001.5 1054 L 1002.5 1052 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_487"
          d="M 1078.5 1053 L 1080.5 1056 L 1078.5 1053 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_488"
          d="M 1320.5 1054 L 1343.5 1078 L 1320.5 1054 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_489"
          d="M 998.5 1055 L 989.5 1065 L 998.5 1055 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_490"
          d="M 1083.5 1057 L 1087.5 1062 L 1083.5 1057 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_491"
          d="M 1090.5 1065 L 1091.5 1067 L 1090.5 1065 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_492"
          d="M 987.5 1067 L 986.5 1069 L 987.5 1067 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_493"
          d="M 1093.5 1069 L 1094.5 1071 L 1093.5 1069 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_494"
          d="M 738.5 1075 L 731.5 1083 L 738.5 1075 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_495"
          d="M 982.5 1075 L 981.5 1077 L 982.5 1075 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_496"
          d="M 1347.5 1082 L 1351.5 1087 L 1347.5 1082 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_497"
          d="M 728.5 1086 L 724.5 1091 L 728.5 1086 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_498"
          d="M 1354.5 1090 L 1357.5 1094 L 1354.5 1090 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_499"
          d="M 1103.5 1092 L 1104 1094.5 L 1103 1094.5 L 1103.5 1092 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_500"
          d="M 722.5 1093 L 719.5 1097 L 722.5 1093 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_501"
          d="M 975.5 1095 L 976 1097.5 L 975 1097.5 L 975.5 1095 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_502"
          d="M 1359.5 1096 L 1361.5 1099 L 1359.5 1096 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_503"
          d="M 1104.5 1098 L 1105 1113.5 L 1104 1113.5 L 1104.5 1098 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_504"
          d="M 717.5 1099 L 715.5 1102 L 717.5 1099 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_505"
          d="M 1363.5 1101 L 1365.5 1104 L 1363.5 1101 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_506"
          d="M 713.5 1104 L 712.5 1106 L 713.5 1104 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_507"
          d="M 1367.5 1106 L 1369.5 1109 L 1367.5 1106 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_508"
          d="M 710.5 1108 L 709.5 1110 L 710.5 1108 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_509"
          d="M 1370.5 1110 L 1371.5 1112 L 1370.5 1110 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_510"
          d="M 707.5 1112 L 706.5 1114 L 707.5 1112 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_511"
          d="M 975.5 1114 L 976 1116.5 L 975 1116.5 L 975.5 1114 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_512"
          d="M 1373.5 1114 L 1374.5 1116 L 1373.5 1114 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_513"
          d="M 851.5 1115 L 856 1115.5 L 851.5 1116 L 851.5 1115 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_514"
          d="M 867.5 1115 L 871 1115.5 L 867.5 1116 L 867.5 1115 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_515"
          d="M 1210.5 1115 L 1226 1115.5 L 1210.5 1116 L 1210.5 1115 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_516"
          d="M 704.5 1116 L 703.5 1118 L 704.5 1116 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_517"
          d="M 846.5 1116 L 849 1116.5 L 846.5 1117 L 846.5 1116 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_518"
          d="M 1204.5 1116 L 1207 1116.5 L 1204.5 1117 L 1204.5 1116 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_519"
          d="M 1103.5 1117 L 1104 1119.5 L 1103 1119.5 L 1103.5 1117 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_520"
          d="M 1376.5 1118 L 1377.5 1120 L 1376.5 1118 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_521"
          d="M 1378.5 1121 L 1379.5 1123 L 1378.5 1121 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_522"
          d="M 830.5 1122 L 829.5 1124 L 830.5 1122 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_523"
          d="M 699.5 1123 L 698.5 1125 L 699.5 1123 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_524"
          d="M 895.5 1124 L 896.5 1126 L 895.5 1124 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_525"
          d="M 1184.5 1124 L 1183.5 1126 L 1184.5 1124 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_526"
          d="M 825.5 1125 L 824.5 1127 L 825.5 1125 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_527"
          d="M 697.5 1126 L 696.5 1128 L 697.5 1126 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_528"
          d="M 898.5 1126 L 899.5 1128 L 898.5 1126 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_529"
          d="M 1181.5 1126 L 1180.5 1128 L 1181.5 1126 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_530"
          d="M 1256.5 1127 L 1257.5 1129 L 1256.5 1127 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_531"
          d="M 821.5 1128 L 819.5 1131 L 821.5 1128 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_532"
          d="M 1178.5 1128 L 1175.5 1132 L 1178.5 1128 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_533"
          d="M 695.5 1129 L 694.5 1131 L 695.5 1129 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_534"
          d="M 902.5 1129 L 911.5 1139 L 902.5 1129 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_535"
          d="M 1260.5 1130 L 1268.5 1139 L 1260.5 1130 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_536"
          d="M 693.5 1132 L 692.5 1134 L 693.5 1132 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_537"
          d="M 815.5 1133 L 814.5 1135 L 815.5 1133 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_538"
          d="M 1812.5 1135 L 1813 1137.5 L 1812 1137.5 L 1812.5 1135 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_539"
          d="M 1388.5 1136 L 1389.5 1138 L 1388.5 1136 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_540"
          d="M 1169.5 1137 L 1166.5 1141 L 1169.5 1137 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_541"
          d="M 811.5 1138 L 809.5 1141 L 811.5 1138 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_542"
          d="M 688.5 1140 L 687.5 1142 L 688.5 1140 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_543"
          d="M 984.5 1140 L 985.5 1142 L 984.5 1140 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_544"
          d="M 913.5 1141 L 914.5 1143 L 913.5 1141 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_545"
          d="M 1270.5 1141 L 1271.5 1143 L 1270.5 1141 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_546"
          d="M 265.5 1142 L 266 1144.5 L 265 1144.5 L 265.5 1142 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_547"
          d="M 1165.5 1142 L 1164.5 1144 L 1165.5 1142 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_548"
          d="M 986.5 1143 L 987.5 1145 L 986.5 1143 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_549"
          d="M 915.5 1144 L 916.5 1146 L 915.5 1144 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_550"
          d="M 1272.5 1144 L 1273.5 1146 L 1272.5 1144 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_551"
          d="M 685.5 1145 L 684.5 1147 L 685.5 1145 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_552"
          d="M 1091.5 1145 L 1089.5 1148 L 1091.5 1145 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_553"
          d="M 1163.5 1145 L 1162.5 1147 L 1163.5 1145 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_554"
          d="M 989.5 1147 L 997.5 1156 L 989.5 1147 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_555"
          d="M 1275.5 1149 L 1276.5 1151 L 1275.5 1149 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_556"
          d="M 682.5 1150 L 681.5 1152 L 682.5 1150 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_557"
          d="M 263.5 1151 L 264 1153.5 L 263 1153.5 L 263.5 1151 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_558"
          d="M 1086.5 1151 L 1085.5 1153 L 1086.5 1151 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_559"
          d="M 1816.5 1153 L 1817 1155.5 L 1816 1155.5 L 1816.5 1153 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_560"
          d="M 1081.5 1155 L 1079.5 1158 L 1081.5 1155 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_561"
          d="M 262.5 1156 L 263 1158.5 L 262 1158.5 L 262.5 1156 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_562"
          d="M 1000.5 1157 L 1001.5 1159 L 1000.5 1157 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_563"
          d="M 1401.5 1158 L 1402.5 1160 L 1401.5 1158 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_564"
          d="M 1817.5 1158 L 1818 1160.5 L 1817 1160.5 L 1817.5 1158 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_565"
          d="M 1076.5 1159 L 1075.5 1161 L 1076.5 1159 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_566"
          d="M 261.5 1161 L 262 1163.5 L 261 1163.5 L 261.5 1161 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_567"
          d="M 1071.5 1162 L 1070.5 1164 L 1071.5 1162 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_568"
          d="M 1818.5 1163 L 1819 1165.5 L 1818 1165.5 L 1818.5 1163 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_569"
          d="M 924.5 1164 L 925 1166.5 L 924 1166.5 L 924.5 1164 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_570"
          d="M 797.5 1166 L 798 1168.5 L 797 1168.5 L 797.5 1166 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_571"
          d="M 1154.5 1166 L 1155 1168.5 L 1154 1168.5 L 1154.5 1166 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_572"
          d="M 1282.5 1168 L 1283 1170.5 L 1282 1170.5 L 1282.5 1168 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_573"
          d="M 925.5 1169 L 926 1172.5 L 925 1172.5 L 925.5 1169 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_574"
          d="M 1052.5 1169 L 1055 1169.5 L 1052.5 1170 L 1052.5 1169 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_575"
          d="M 1819.5 1169 L 1820 1171.5 L 1819 1171.5 L 1819.5 1169 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_576"
          d="M 1030.5 1170 L 1035 1170.5 L 1030.5 1171 L 1030.5 1170 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_577"
          d="M 1044.5 1170 L 1049 1170.5 L 1044.5 1171 L 1044.5 1170 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_578"
          d="M 259.5 1172 L 260 1174.5 L 259 1174.5 L 259.5 1172 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_579"
          d="M 796.5 1173 L 797 1186.5 L 796 1186.5 L 796.5 1173 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_580"
          d="M 1153.5 1173 L 1154 1186.5 L 1153 1186.5 L 1153.5 1173 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_581"
          d="M 1820.5 1174 L 1821 1176.5 L 1820 1176.5 L 1820.5 1174 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_582"
          d="M 258.5 1178 L 259 1180.5 L 258 1180.5 L 258.5 1178 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_583"
          d="M 1283.5 1178 L 1284 1181.5 L 1283 1181.5 L 1283.5 1178 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_584"
          d="M 1821.5 1180 L 1822 1182.5 L 1821 1182.5 L 1821.5 1180 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_585"
          d="M 257.5 1184 L 258 1186.5 L 257 1186.5 L 257.5 1184 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_586"
          d="M 925.5 1187 L 926 1190.5 L 925 1190.5 L 925.5 1187 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_587"
          d="M 1822.5 1187 L 1823 1189.5 L 1822 1189.5 L 1822.5 1187 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_588"
          d="M 1282.5 1189 L 1283 1191.5 L 1282 1191.5 L 1282.5 1189 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_589"
          d="M 256.5 1191 L 257 1193.5 L 256 1193.5 L 256.5 1191 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_590"
          d="M 1154.5 1191 L 1155 1193.5 L 1154 1193.5 L 1154.5 1191 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_591"
          d="M 924.5 1193 L 925 1195.5 L 924 1195.5 L 924.5 1193 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_592"
          d="M 1823.5 1193 L 1824 1196.5 L 1823 1196.5 L 1823.5 1193 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_593"
          d="M 255.5 1198 L 256 1200.5 L 255 1200.5 L 255.5 1198 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_594"
          d="M 1824.5 1201 L 1825 1204.5 L 1824 1204.5 L 1824.5 1201 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_595"
          d="M 254.5 1205 L 255 1208.5 L 254 1208.5 L 254.5 1205 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_596"
          d="M 1276.5 1209 L 1275.5 1211 L 1276.5 1209 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_597"
          d="M 1825.5 1209 L 1826 1212.5 L 1825 1212.5 L 1825.5 1209 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_598"
          d="M 1162.5 1213 L 1163.5 1215 L 1162.5 1213 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_599"
          d="M 253.5 1214 L 254 1217.5 L 253 1217.5 L 253.5 1214 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_600"
          d="M 916.5 1214 L 915.5 1216 L 916.5 1214 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_601"
          d="M 1273.5 1214 L 1272.5 1216 L 1273.5 1214 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_602"
          d="M 807.5 1216 L 808.5 1218 L 807.5 1216 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_603"
          d="M 1164.5 1216 L 1165.5 1218 L 1164.5 1216 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_604"
          d="M 914.5 1217 L 913.5 1219 L 914.5 1217 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_605"
          d="M 1271.5 1217 L 1270.5 1219 L 1271.5 1217 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_606"
          d="M 1826.5 1218 L 1827 1222.5 L 1826 1222.5 L 1826.5 1218 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_607"
          d="M 809.5 1219 L 811.5 1222 L 809.5 1219 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_608"
          d="M 1167.5 1220 L 1169.5 1223 L 1167.5 1220 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_609"
          d="M 911.5 1221 L 902.5 1231 L 911.5 1221 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_610"
          d="M 1268.5 1221 L 1260.5 1230 L 1268.5 1221 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_611"
          d="M 252.5 1223 L 253 1228.5 L 252 1228.5 L 252.5 1223 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_612"
          d="M 1175.5 1228 L 1177.5 1231 L 1175.5 1228 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_613"
          d="M 1827.5 1228 L 1828 1233.5 L 1827 1233.5 L 1827.5 1228 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_614"
          d="M 819.5 1229 L 821.5 1232 L 819.5 1229 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_615"
          d="M 1257.5 1231 L 1256.5 1233 L 1257.5 1231 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_616"
          d="M 899.5 1232 L 898.5 1234 L 899.5 1232 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_617"
          d="M 1180.5 1232 L 1181.5 1234 L 1180.5 1232 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_618"
          d="M 896.5 1234 L 895.5 1236 L 896.5 1234 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_619"
          d="M 1183.5 1234 L 1184.5 1236 L 1183.5 1234 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_620"
          d="M 251.5 1235 L 252 1241.5 L 251 1241.5 L 251.5 1235 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_621"
          d="M 1251.5 1235 L 1250.5 1237 L 1251.5 1235 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_622"
          d="M 1828.5 1241 L 1829 1248.5 L 1828 1248.5 L 1828.5 1241 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_623"
          d="M 846.5 1243 L 849 1243.5 L 846.5 1244 L 846.5 1243 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_624"
          d="M 1204.5 1243 L 1207 1243.5 L 1204.5 1244 L 1204.5 1243 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_625"
          d="M 852.5 1244 L 857 1244.5 L 852.5 1245 L 852.5 1244 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_626"
          d="M 866.5 1244 L 871 1244.5 L 866.5 1245 L 866.5 1244 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_627"
          d="M 1036.5 1244 L 1044 1244.5 L 1036.5 1245 L 1036.5 1244 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_628"
          d="M 1210.5 1244 L 1226 1244.5 L 1210.5 1245 L 1210.5 1244 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_629"
          d="M 1024.5 1245 L 1028 1245.5 L 1024.5 1246 L 1024.5 1245 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_630"
          d="M 1051.5 1245 L 1056 1245.5 L 1051.5 1246 L 1051.5 1245 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_631"
          d="M 1018.5 1246 L 1021 1246.5 L 1018.5 1247 L 1018.5 1246 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_632"
          d="M 1059.5 1246 L 1062 1246.5 L 1059.5 1247 L 1059.5 1246 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_633"
          d="M 250.5 1250 L 251 1259.5 L 250 1259.5 L 250.5 1250 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_634"
          d="M 988.5 1256 L 990 1256.5 L 987.5 1258 L 988.5 1256 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_635"
          d="M 1096.5 1259 L 1097.5 1261 L 1096.5 1259 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_636"
          d="M 1829.5 1259 L 1830 1275.5 L 1829 1275.5 L 1829.5 1259 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_637"
          d="M 1442.5 1263 L 1443 1265.5 L 1442 1265.5 L 1442.5 1263 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_638"
          d="M 636.5 1265 L 637 1267.5 L 636 1267.5 L 636.5 1265 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_639"
          d="M 972.5 1266 L 971.5 1268 L 972.5 1266 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_640"
          d="M 1108.5 1267 L 1110.5 1270 L 1108.5 1267 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_641"
          d="M 968.5 1269 L 966.5 1272 L 968.5 1269 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_642"
          d="M 1113.5 1271 L 1127.5 1286 L 1113.5 1271 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_643"
          d="M 1444.5 1272 L 1445 1274.5 L 1444 1274.5 L 1444.5 1272 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_644"
          d="M 962.5 1274 L 955.5 1282 L 962.5 1274 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_645"
          d="M 1445.5 1277 L 1446 1279.5 L 1445 1279.5 L 1445.5 1277 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_646"
          d="M 249.5 1280 L 250 1738.5 L 249 1738.5 L 249.5 1280 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_647"
          d="M 1446.5 1282 L 1447 1284.5 L 1446 1284.5 L 1446.5 1282 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_648"
          d="M 632.5 1285 L 633 1287.5 L 632 1287.5 L 632.5 1285 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_649"
          d="M 952.5 1285 L 950.5 1288 L 952.5 1285 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_650"
          d="M 1129.5 1288 L 1130.5 1290 L 1129.5 1288 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_651"
          d="M 1447.5 1288 L 1448 1290.5 L 1447 1290.5 L 1447.5 1288 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_652"
          d="M 948.5 1290 L 947.5 1292 L 948.5 1290 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_653"
          d="M 631.5 1291 L 632 1293.5 L 631 1293.5 L 631.5 1291 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_654"
          d="M 1132.5 1292 L 1133.5 1294 L 1132.5 1292 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_655"
          d="M 782.5 1293 L 793 1293.5 L 782.5 1294 L 782.5 1293 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_656"
          d="M 775.5 1294 L 778 1294.5 L 775.5 1295 L 775.5 1294 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_657"
          d="M 797.5 1294 L 800 1294.5 L 797.5 1295 L 797.5 1294 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_658"
          d="M 1448.5 1294 L 1449 1296.5 L 1448 1296.5 L 1448.5 1294 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_659"
          d="M 1134.5 1295 L 1135.5 1297 L 1134.5 1295 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_660"
          d="M 630.5 1297 L 631 1299.5 L 630 1299.5 L 630.5 1297 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_661"
          d="M 942.5 1299 L 941.5 1301 L 942.5 1299 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_662"
          d="M 1449.5 1300 L 1450 1303.5 L 1449 1303.5 L 1449.5 1300 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_663"
          d="M 752.5 1303 L 751.5 1305 L 752.5 1303 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_664"
          d="M 822.5 1303 L 823.5 1305 L 822.5 1303 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_665"
          d="M 629.5 1304 L 630 1307.5 L 629 1307.5 L 629.5 1304 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_666"
          d="M 749.5 1305 L 748.5 1307 L 749.5 1305 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_667"
          d="M 826.5 1306 L 827.5 1308 L 826.5 1306 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_668"
          d="M 745.5 1308 L 737.5 1317 L 745.5 1308 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_669"
          d="M 1450.5 1308 L 1451 1311.5 L 1450 1311.5 L 1450.5 1308 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_670"
          d="M 830.5 1309 L 836.5 1316 L 830.5 1309 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_671"
          d="M 628.5 1312 L 629 1316.5 L 628 1316.5 L 628.5 1312 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_672"
          d="M 1451.5 1317 L 1452 1321.5 L 1451 1321.5 L 1451.5 1317 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_673"
          d="M 838.5 1318 L 839.5 1320 L 838.5 1318 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_674"
          d="M 735.5 1319 L 734.5 1321 L 735.5 1319 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_675"
          d="M 627.5 1322 L 628 1327.5 L 627 1327.5 L 627.5 1322 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_676"
          d="M 733.5 1322 L 732.5 1324 L 733.5 1322 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_677"
          d="M 730.5 1327 L 729.5 1329 L 730.5 1327 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_678"
          d="M 1452.5 1328 L 1453 1335.5 L 1452 1335.5 L 1452.5 1328 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_679"
          d="M 1151.5 1335 L 1152 1337.5 L 1151 1337.5 L 1151.5 1335 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_680"
          d="M 626.5 1336 L 627 1347.5 L 626 1347.5 L 626.5 1336 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_681"
          d="M 927.5 1338 L 928 1340.5 L 927 1340.5 L 927.5 1338 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_682"
          d="M 1152.5 1341 L 1153 1343.5 L 1152 1343.5 L 1152.5 1341 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_683"
          d="M 926.5 1345 L 927 1349.5 L 926 1349.5 L 926.5 1345 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_684"
          d="M 851.5 1346 L 852 1348.5 L 851 1348.5 L 851.5 1346 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_685"
          d="M 1453.5 1348 L 1454 1368.5 L 1453 1368.5 L 1453.5 1348 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_686"
          d="M 1153.5 1349 L 1154 1367.5 L 1153 1367.5 L 1153.5 1349 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_687"
          d="M 722.5 1353 L 723 1363.5 L 722 1363.5 L 722.5 1353 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_688"
          d="M 852.5 1354 L 853 1362.5 L 852 1362.5 L 852.5 1354 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_689"
          d="M 926.5 1367 L 927 1371.5 L 926 1371.5 L 926.5 1367 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_690"
          d="M 851.5 1368 L 852 1370.5 L 851 1370.5 L 851.5 1368 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_691"
          d="M 626.5 1370 L 627 1380.5 L 626 1380.5 L 626.5 1370 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_692"
          d="M 1152.5 1373 L 1153 1375.5 L 1152 1375.5 L 1152.5 1373 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_693"
          d="M 927.5 1376 L 928 1378.5 L 927 1378.5 L 927.5 1376 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_694"
          d="M 1151.5 1379 L 1152 1381.5 L 1151 1381.5 L 1151.5 1379 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_695"
          d="M 1452.5 1381 L 1453 1388.5 L 1452 1388.5 L 1452.5 1381 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_696"
          d="M 729.5 1388 L 730.5 1390 L 729.5 1388 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_697"
          d="M 627.5 1389 L 628 1394.5 L 627 1394.5 L 627.5 1389 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_698"
          d="M 732.5 1393 L 733.5 1395 L 732.5 1393 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_699"
          d="M 1451.5 1395 L 1452 1399.5 L 1451 1399.5 L 1451.5 1395 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_700"
          d="M 734.5 1396 L 735.5 1398 L 734.5 1396 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_701"
          d="M 839.5 1397 L 838.5 1399 L 839.5 1397 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_702"
          d="M 628.5 1400 L 629 1404.5 L 628 1404.5 L 628.5 1400 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_703"
          d="M 737.5 1400 L 745.5 1409 L 737.5 1400 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_704"
          d="M 836.5 1401 L 830.5 1408 L 836.5 1401 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_705"
          d="M 1450.5 1405 L 1451 1408.5 L 1450 1408.5 L 1450.5 1405 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_706"
          d="M 629.5 1409 L 630 1412.5 L 629 1412.5 L 629.5 1409 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_707"
          d="M 827.5 1409 L 826.5 1411 L 827.5 1409 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_708"
          d="M 748.5 1410 L 749.5 1412 L 748.5 1410 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_709"
          d="M 751.5 1412 L 752.5 1414 L 751.5 1412 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_710"
          d="M 823.5 1412 L 822.5 1414 L 823.5 1412 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_711"
          d="M 1449.5 1413 L 1450 1415.5 L 1449 1415.5 L 1449.5 1413 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_712"
          d="M 756.5 1415 L 757.5 1417 L 756.5 1415 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_713"
          d="M 941.5 1416 L 942.5 1418 L 941.5 1416 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_714"
          d="M 630.5 1417 L 631 1419.5 L 630 1419.5 L 630.5 1417 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_715"
          d="M 1135.5 1420 L 1134.5 1422 L 1135.5 1420 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_716"
          d="M 1448.5 1420 L 1449 1422.5 L 1448 1422.5 L 1448.5 1420 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_717"
          d="M 775.5 1422 L 778 1422.5 L 775.5 1423 L 775.5 1422 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_718"
          d="M 797.5 1422 L 800 1422.5 L 797.5 1423 L 797.5 1422 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_719"
          d="M 631.5 1423 L 632 1425.5 L 631 1425.5 L 631.5 1423 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_720"
          d="M 782.5 1423 L 793 1423.5 L 782.5 1424 L 782.5 1423 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_721"
          d="M 1133.5 1423 L 1132.5 1425 L 1133.5 1423 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_722"
          d="M 947.5 1425 L 948.5 1427 L 947.5 1425 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_723"
          d="M 1447.5 1426 L 1448 1428.5 L 1447 1428.5 L 1447.5 1426 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_724"
          d="M 1130.5 1427 L 1129.5 1429 L 1130.5 1427 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_725"
          d="M 632.5 1429 L 633 1431.5 L 632 1431.5 L 632.5 1429 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_726"
          d="M 950.5 1429 L 952.5 1432 L 950.5 1429 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_727"
          d="M 1127.5 1431 L 1113.5 1446 L 1127.5 1431 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_728"
          d="M 1446.5 1432 L 1447 1434.5 L 1446 1434.5 L 1446.5 1432 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_729"
          d="M 955.5 1435 L 962.5 1443 L 955.5 1435 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_730"
          d="M 1445.5 1437 L 1446 1439.5 L 1445 1439.5 L 1445.5 1437 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_731"
          d="M 1444.5 1442 L 1445 1444.5 L 1444 1444.5 L 1444.5 1442 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_732"
          d="M 966.5 1445 L 968.5 1448 L 966.5 1445 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_733"
          d="M 1110.5 1447 L 1108.5 1450 L 1110.5 1447 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_734"
          d="M 636.5 1449 L 637 1451.5 L 636 1451.5 L 636.5 1449 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_735"
          d="M 971.5 1449 L 972.5 1451 L 971.5 1449 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_736"
          d="M 1441.5 1455 L 1442 1457.5 L 1441 1457.5 L 1441.5 1455 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_737"
          d="M 1097.5 1456 L 1096.5 1458 L 1097.5 1456 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_738"
          d="M 987.5 1459 L 988.5 1461 L 987.5 1459 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_739"
          d="M 1018.5 1470 L 1021 1470.5 L 1018.5 1471 L 1018.5 1470 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_740"
          d="M 1059.5 1470 L 1062 1470.5 L 1059.5 1471 L 1059.5 1470 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_741"
          d="M 1024.5 1471 L 1028 1471.5 L 1024.5 1472 L 1024.5 1471 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_742"
          d="M 1052.5 1471 L 1056 1471.5 L 1052.5 1472 L 1052.5 1471 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_743"
          d="M 851.5 1472 L 854 1472.5 L 851.5 1473 L 851.5 1472 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_744"
          d="M 868.5 1472 L 872 1472.5 L 868.5 1473 L 868.5 1472 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_745"
          d="M 1035.5 1472 L 1045 1472.5 L 1035.5 1473 L 1035.5 1472 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_746"
          d="M 1207.5 1472 L 1211 1472.5 L 1207.5 1473 L 1207.5 1472 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_747"
          d="M 1225.5 1472 L 1229 1472.5 L 1225.5 1473 L 1225.5 1472 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_748"
          d="M 828.5 1480 L 827.5 1482 L 828.5 1480 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_749"
          d="M 1252.5 1481 L 1253.5 1483 L 1252.5 1481 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_750"
          d="M 825.5 1482 L 824.5 1484 L 825.5 1482 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_751"
          d="M 1255.5 1483 L 1256.5 1485 L 1255.5 1483 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_752"
          d="M 822.5 1484 L 820.5 1487 L 822.5 1484 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_753"
          d="M 1179.5 1484 L 1178.5 1486 L 1179.5 1484 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_754"
          d="M 901.5 1485 L 904.5 1489 L 901.5 1485 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_755"
          d="M 1259.5 1486 L 1268.5 1496 L 1259.5 1486 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_756"
          d="M 1175.5 1487 L 1168.5 1495 L 1175.5 1487 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_757"
          d="M 817.5 1488 L 813.5 1493 L 817.5 1488 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_758"
          d="M 909.5 1493 L 912.5 1497 L 909.5 1493 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_759"
          d="M 810.5 1496 L 809.5 1498 L 810.5 1496 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_760"
          d="M 1166.5 1497 L 1165.5 1499 L 1166.5 1497 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_761"
          d="M 1270.5 1498 L 1271.5 1500 L 1270.5 1498 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_762"
          d="M 1164.5 1500 L 1163.5 1502 L 1164.5 1500 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_763"
          d="M 1162.5 1503 L 1161.5 1505 L 1162.5 1503 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_764"
          d="M 917.5 1504 L 918.5 1506 L 917.5 1504 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_765"
          d="M 797.5 1523 L 798 1525.5 L 797 1525.5 L 797.5 1523 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_766"
          d="M 925.5 1525 L 926 1527.5 L 925 1527.5 L 925.5 1525 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_767"
          d="M 1282.5 1525 L 1283 1528.5 L 1282 1528.5 L 1282.5 1525 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_768"
          d="M 1153.5 1528 L 1154 1533.5 L 1153 1533.5 L 1153.5 1528 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_769"
          d="M 796.5 1530 L 797 1543.5 L 796 1543.5 L 796.5 1530 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_770"
          d="M 926.5 1535 L 927 1537.5 L 926 1537.5 L 926.5 1535 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_771"
          d="M 1153.5 1539 L 1154 1544.5 L 1153 1544.5 L 1153.5 1539 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_772"
          d="M 925.5 1545 L 926 1548.5 L 925 1548.5 L 925.5 1545 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_773"
          d="M 1282.5 1545 L 1283 1547.5 L 1282 1547.5 L 1282.5 1545 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_774"
          d="M 1029.5 1546 L 1033 1546.5 L 1029.5 1547 L 1029.5 1546 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_775"
          d="M 1047.5 1546 L 1051 1546.5 L 1047.5 1547 L 1047.5 1546 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_776"
          d="M 1010.5 1552 L 1009.5 1554 L 1010.5 1552 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_777"
          d="M 1002.5 1557 L 1001.5 1559 L 1002.5 1557 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_778"
          d="M 1078.5 1558 L 1079.5 1560 L 1078.5 1558 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_779"
          d="M 999.5 1559 L 988.5 1571 L 999.5 1559 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_780"
          d="M 1083.5 1562 L 1088.5 1568 L 1083.5 1562 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_781"
          d="M 681.5 1565 L 682.5 1567 L 681.5 1565 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_782"
          d="M 1395.5 1569 L 1394.5 1571 L 1395.5 1569 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_783"
          d="M 684.5 1570 L 685.5 1572 L 684.5 1570 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_784"
          d="M 805.5 1570 L 806.5 1572 L 805.5 1570 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_785"
          d="M 1090.5 1570 L 1092.5 1573 L 1090.5 1570 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_786"
          d="M 916.5 1571 L 915.5 1573 L 916.5 1571 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_787"
          d="M 987.5 1572 L 986.5 1574 L 987.5 1572 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_788"
          d="M 807.5 1573 L 808.5 1575 L 807.5 1573 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_789"
          d="M 914.5 1574 L 913.5 1576 L 914.5 1574 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_790"
          d="M 1093.5 1574 L 1094.5 1576 L 1093.5 1574 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_791"
          d="M 1392.5 1574 L 1391.5 1576 L 1392.5 1574 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_792"
          d="M 687.5 1575 L 688.5 1577 L 687.5 1575 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_793"
          d="M 1270.5 1575 L 1269.5 1577 L 1270.5 1575 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_794"
          d="M 1166.5 1576 L 1168.5 1579 L 1166.5 1576 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_795"
          d="M 810.5 1577 L 812.5 1580 L 810.5 1577 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_796"
          d="M 911.5 1578 L 903.5 1587 L 911.5 1578 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_797"
          d="M 1267.5 1579 L 1260.5 1587 L 1267.5 1579 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_798"
          d="M 1171.5 1582 L 1172.5 1584 L 1171.5 1582 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_799"
          d="M 1387.5 1582 L 1386.5 1584 L 1387.5 1582 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_800"
          d="M 692.5 1583 L 693.5 1585 L 692.5 1583 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_801"
          d="M 818.5 1585 L 821.5 1589 L 818.5 1585 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_802"
          d="M 1385.5 1585 L 1384.5 1587 L 1385.5 1585 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_803"
          d="M 694.5 1586 L 695.5 1588 L 694.5 1586 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_804"
          d="M 1176.5 1586 L 1178.5 1589 L 1176.5 1586 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_805"
          d="M 900.5 1588 L 899.5 1590 L 900.5 1588 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_806"
          d="M 1257.5 1588 L 1256.5 1590 L 1257.5 1588 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_807"
          d="M 1383.5 1588 L 1382.5 1590 L 1383.5 1588 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_808"
          d="M 696.5 1589 L 697.5 1591 L 696.5 1589 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_809"
          d="M 823.5 1589 L 824.5 1591 L 823.5 1589 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_810"
          d="M 1381.5 1591 L 1380.5 1593 L 1381.5 1591 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_811"
          d="M 698.5 1592 L 699.5 1594 L 698.5 1592 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_812"
          d="M 1251.5 1592 L 1250.5 1594 L 1251.5 1592 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_813"
          d="M 1188.5 1594 L 1191 1595.5 L 1189.5 1596 L 1188.5 1594 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_814"
          d="M 1376.5 1598 L 1375.5 1600 L 1376.5 1598 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_815"
          d="M 703.5 1599 L 704.5 1601 L 703.5 1599 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_816"
          d="M 873.5 1600 L 876 1600.5 L 873.5 1601 L 873.5 1600 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_817"
          d="M 975.5 1600 L 976 1602.5 L 975 1602.5 L 975.5 1600 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_818"
          d="M 1230.5 1600 L 1233 1600.5 L 1230.5 1601 L 1230.5 1600 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_819"
          d="M 853.5 1601 L 859 1601.5 L 853.5 1602 L 853.5 1601 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_820"
          d="M 864.5 1601 L 870 1601.5 L 864.5 1602 L 864.5 1601 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_821"
          d="M 1209.5 1601 L 1215 1601.5 L 1209.5 1602 L 1209.5 1601 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_822"
          d="M 1221.5 1601 L 1227 1601.5 L 1221.5 1602 L 1221.5 1601 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_823"
          d="M 1374.5 1601 L 1372.5 1604 L 1374.5 1601 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_824"
          d="M 706.5 1603 L 707.5 1605 L 706.5 1603 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_825"
          d="M 1104.5 1603 L 1105 1618.5 L 1104 1618.5 L 1104.5 1603 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_826"
          d="M 1371.5 1605 L 1369.5 1608 L 1371.5 1605 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_827"
          d="M 709.5 1607 L 710.5 1609 L 709.5 1607 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_828"
          d="M 1368.5 1609 L 1366.5 1612 L 1368.5 1609 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_829"
          d="M 712.5 1611 L 713.5 1613 L 712.5 1611 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_830"
          d="M 1364.5 1614 L 1362.5 1617 L 1364.5 1614 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_831"
          d="M 715.5 1615 L 717.5 1618 L 715.5 1615 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_832"
          d="M 975.5 1619 L 976 1621.5 L 975 1621.5 L 975.5 1619 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_833"
          d="M 1360.5 1619 L 1358.5 1622 L 1360.5 1619 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_834"
          d="M 719.5 1620 L 722.5 1624 L 719.5 1620 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_835"
          d="M 1103.5 1622 L 1104 1624.5 L 1103 1624.5 L 1103.5 1622 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_836"
          d="M 1356.5 1624 L 1352.5 1629 L 1356.5 1624 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_837"
          d="M 724.5 1626 L 728.5 1631 L 724.5 1626 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_838"
          d="M 1350.5 1631 L 1344.5 1638 L 1350.5 1631 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_839"
          d="M 731.5 1634 L 738.5 1642 L 731.5 1634 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_840"
          d="M 1340.5 1642 L 1324.5 1659 L 1340.5 1642 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_841"
          d="M 984.5 1645 L 985.5 1647 L 984.5 1645 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_842"
          d="M 1093.5 1647 L 1092.5 1649 L 1093.5 1647 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_843"
          d="M 986.5 1648 L 988.5 1651 L 986.5 1648 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_844"
          d="M 1091.5 1650 L 1089.5 1653 L 1091.5 1650 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_845"
          d="M 990.5 1653 L 997.5 1661 L 990.5 1653 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_846"
          d="M 756.5 1659 L 763.5 1667 L 756.5 1659 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_847"
          d="M 1081.5 1660 L 1079.5 1663 L 1081.5 1660 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_848"
          d="M 1000.5 1662 L 1001.5 1664 L 1000.5 1662 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_849"
          d="M 1318.5 1663 L 1313.5 1669 L 1318.5 1663 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_850"
          d="M 1006.5 1666 L 1007.5 1668 L 1006.5 1666 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_851"
          d="M 767.5 1669 L 771.5 1674 L 767.5 1669 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_852"
          d="M 1309.5 1671 L 1306.5 1675 L 1309.5 1671 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_853"
          d="M 1025.5 1674 L 1028 1674.5 L 1025.5 1675 L 1025.5 1674 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_854"
          d="M 774.5 1675 L 777.5 1679 L 774.5 1675 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_855"
          d="M 1031.5 1675 L 1048 1675.5 L 1031.5 1676 L 1031.5 1675 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_856"
          d="M 1302.5 1677 L 1300.5 1680 L 1302.5 1677 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_857"
          d="M 780.5 1680 L 782.5 1683 L 780.5 1680 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_858"
          d="M 1297.5 1681 L 1295.5 1684 L 1297.5 1681 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_859"
          d="M 785.5 1684 L 787.5 1687 L 785.5 1684 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_860"
          d="M 1292.5 1685 L 1291.5 1687 L 1292.5 1685 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_861"
          d="M 789.5 1687 L 791.5 1690 L 789.5 1687 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_862"
          d="M 1288.5 1688 L 1287.5 1690 L 1288.5 1688 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_863"
          d="M 793.5 1690 L 795.5 1693 L 793.5 1690 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_864"
          d="M 1284.5 1691 L 1283.5 1693 L 1284.5 1691 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_865"
          d="M 797.5 1693 L 798.5 1695 L 797.5 1693 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_866"
          d="M 1280.5 1694 L 1279.5 1696 L 1280.5 1694 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_867"
          d="M 801.5 1696 L 802.5 1698 L 801.5 1696 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_868"
          d="M 1277.5 1696 L 1276.5 1698 L 1277.5 1696 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_869"
          d="M 804.5 1698 L 805.5 1700 L 804.5 1698 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_870"
          d="M 807.5 1700 L 808.5 1702 L 807.5 1700 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_871"
          d="M 810.5 1702 L 811.5 1704 L 810.5 1702 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_872"
          d="M 813.5 1704 L 814.5 1706 L 813.5 1704 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_873"
          d="M 816.5 1706 L 817.5 1708 L 816.5 1706 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_874"
          d="M 1262.5 1706 L 1261.5 1708 L 1262.5 1706 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_875"
          d="M 1254.5 1711 L 1253.5 1713 L 1254.5 1711 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_876"
          d="M 1249.5 1714 L 1248.5 1716 L 1249.5 1714 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_877"
          d="M 1242.5 1718 L 1241.5 1720 L 1242.5 1718 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_878"
          d="M 1829.5 1741 L 1830 1749.5 L 1829 1749.5 L 1829.5 1741 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_879"
          d="M 250.5 1750 L 251 1755.5 L 250 1755.5 L 250.5 1750 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_880"
          d="M 1828.5 1756 L 1829 1759.5 L 1828 1759.5 L 1828.5 1756 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_881"
          d="M 251.5 1760 L 252 1763.5 L 251 1763.5 L 251.5 1760 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_882"
          d="M 941.5 1760 L 944 1760.5 L 941.5 1761 L 941.5 1760 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_883"
          d="M 1121.5 1763 L 1124 1763.5 L 1121.5 1764 L 1121.5 1763 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_884"
          d="M 1116.5 1764 L 1119 1764.5 L 1116.5 1765 L 1116.5 1764 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_885"
          d="M 1827.5 1764 L 1828 1766.5 L 1827 1766.5 L 1827.5 1764 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_886"
          d="M 965.5 1765 L 968 1765.5 L 965.5 1766 L 965.5 1765 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_887"
          d="M 970.5 1766 L 973 1766.5 L 970.5 1767 L 970.5 1766 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_888"
          d="M 1105.5 1766 L 1108 1766.5 L 1105.5 1767 L 1105.5 1766 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_889"
          d="M 252.5 1767 L 253 1769.5 L 252 1769.5 L 252.5 1767 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_890"
          d="M 977.5 1767 L 980 1767.5 L 977.5 1768 L 977.5 1767 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_891"
          d="M 1098.5 1767 L 1101 1767.5 L 1098.5 1768 L 1098.5 1767 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_892"
          d="M 983.5 1768 L 987 1768.5 L 983.5 1769 L 983.5 1768 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_893"
          d="M 1091.5 1768 L 1094 1768.5 L 1091.5 1769 L 1091.5 1768 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_894"
          d="M 991.5 1769 L 996 1769.5 L 991.5 1770 L 991.5 1769 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_895"
          d="M 1082.5 1769 L 1086 1769.5 L 1082.5 1770 L 1082.5 1769 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_896"
          d="M 1000.5 1770 L 1006 1770.5 L 1000.5 1771 L 1000.5 1770 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_897"
          d="M 1070.5 1770 L 1077 1770.5 L 1070.5 1771 L 1070.5 1770 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_898"
          d="M 1826.5 1770 L 1827 1772.5 L 1826 1772.5 L 1826.5 1770 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_899"
          d="M 1013.5 1771 L 1022 1771.5 L 1013.5 1772 L 1013.5 1771 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_900"
          d="M 1051.5 1771 L 1063 1771.5 L 1051.5 1772 L 1051.5 1771 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_901"
          d="M 253.5 1772 L 254 1774.5 L 253 1774.5 L 253.5 1772 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_902"
          d="M 254.5 1777 L 255 1779.5 L 254 1779.5 L 254.5 1777 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_903"
          d="M 1806.5 1826 L 1805.5 1828 L 1806.5 1826 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_904"
          d="M 275.5 1830 L 276.5 1832 L 275.5 1830 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_905"
          d="M 1801.5 1834 L 1800.5 1836 L 1801.5 1834 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_906"
          d="M 279.5 1836 L 280.5 1838 L 279.5 1836 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_907"
          d="M 281.5 1839 L 283.5 1842 L 281.5 1839 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_908"
          d="M 1796.5 1841 L 1794.5 1844 L 1796.5 1841 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_909"
          d="M 284.5 1843 L 287.5 1847 L 284.5 1843 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_910"
          d="M 1792.5 1846 L 1788.5 1851 L 1792.5 1846 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_911"
          d="M 289.5 1849 L 299.5 1860 L 289.5 1849 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_912"
          d="M 1780.5 1858 L 1776.5 1863 L 1780.5 1858 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_913"
          d="M 302.5 1861 L 305.5 1865 L 302.5 1861 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_914"
          d="M 1773.5 1864 L 1772.5 1866 L 1773.5 1864 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_915"
          d="M 307.5 1865 L 308.5 1867 L 307.5 1865 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_916"
          d="M 1769.5 1867 L 1768.5 1869 L 1769.5 1867 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_917"
          d="M 311.5 1868 L 312.5 1870 L 311.5 1868 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_918"
          d="M 1766.5 1869 L 1765.5 1871 L 1766.5 1869 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_919"
          d="M 351.5 1884 L 356 1884.5 L 351.5 1885 L 351.5 1884 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_920"
          d="M 1724.5 1884 L 1728 1884.5 L 1724.5 1885 L 1724.5 1884 Z"
          fill="currentColor"
          fillOpacity="0.6980392"
          stroke="currentColor"
          strokeOpacity="0.6980392"
          strokeWidth="1"/>
        <path
          id="path_921"
          d="M 1014.5 0 L 1082.5 0 L 1083.5 1 L 1126.5 1 L 1127.5 2 L 1173.5 3 L 1174.5 4 L 1191.5 4 L 1192.5 5 L 1233.5 7 L 1234.5 8 L 1245.5 8 L 1246.5 9 L 1256.5 9 L 1257.5 10 L 1267.5 10 L 1268.5 11 L 1305.5 14 L 1306.5 15 L 1313.5 15 L 1314.5 16 L 1321.5 16 L 1322.5 17 L 1329.5 17 L 1330.5 18 L 1366.5 22 L 1373.5 24 L 1379.5 24 L 1380.5 25 L 1421.5 31 L 1438.5 35 L 1443.5 35 L 1496.5 46 L 1518.5 52 L 1522.5 52 L 1597.5 72 L 1669.5 95 L 1745.5 124 Q 1799.5 146.5 1849.5 173 Q 1906.7 203.3 1958.5 239 Q 1996.7 263.8 2027 296.5 Q 2062.7 334.8 2081 390.5 L 2087 413.5 L 2090 430.5 L 2090 437.5 L 2091 438.5 L 2091 447.5 L 2092 448.5 L 2092 496.5 L 2091 497.5 L 2091 507.5 L 2090 508.5 L 2090 516.5 L 2089 517.5 L 2087 535.5 L 2079 571.5 L 2068 607.5 L 2055 641.5 Q 2022.8 717.8 1976.5 780 Q 1883.8 755.2 1808.5 713 Q 1733 670.5 1676 609.5 L 1651 580.5 L 1651 440 L 1596.5 415 L 1519.5 387 L 1432.5 363 L 1366.5 349 L 1361.5 349 L 1355.5 347 L 1350.5 347 L 1313.5 340 L 1279.5 336 L 1278.5 335 L 1246.5 332 L 1245.5 331 L 1237.5 331 L 1236.5 330 L 1227.5 330 L 1226.5 329 L 1217.5 329 L 1216.5 328 L 1207.5 328 L 1206.5 327 L 1170.5 325 L 1169.5 324 L 1155.5 324 L 1154.5 323 L 1116.5 322 L 1115.5 321 L 1022.5 320 L 1021.5 321 L 986.5 321 L 985.5 322 L 946.5 323 L 945.5 324 L 930.5 324 L 929.5 325 L 917.5 325 L 916.5 326 L 904.5 326 L 903.5 327 L 871.5 329 L 870.5 330 L 835.5 333 L 834.5 334 L 827.5 334 L 826.5 335 L 819.5 335 L 818.5 336 L 784.5 340 L 700.5 355 L 628.5 372 L 558.5 393 L 504.5 413 L 445 440 L 445 579.5 L 429.5 596 Q 362.4 661.9 278.5 711 Q 240.9 732.9 199.5 751 L 151.5 770 L 121.5 780 L 118 780 Q 89.9 744.4 66 703.5 Q 44.4 666.6 28 624.5 L 16 589.5 L 6 548.5 L 4 530.5 L 3 529.5 L 3 522.5 L 2 521.5 L 2 512.5 L 1 511.5 L 0 478.5 L 1 477.5 L 2 450.5 L 7 421.5 L 12 402.5 L 24 370.5 Q 52.4 310.4 99.5 269 Q 132.9 239.4 170.5 214 Q 217 182.5 268.5 156 Q 318.8 130.3 373.5 109 L 408.5 96 L 479.5 73 L 522.5 61 L 603.5 42 L 628.5 37 L 633.5 37 L 644.5 34 L 649.5 34 L 655.5 32 L 660.5 32 L 691.5 26 L 697.5 26 L 704.5 24 L 731.5 21 L 732.5 20 L 739.5 20 L 740.5 19 L 747.5 19 L 748.5 18 L 763.5 17 L 772.5 15 L 780.5 15 L 781.5 14 L 789.5 14 L 790.5 13 L 830.5 10 L 831.5 9 L 842.5 9 L 843.5 8 L 854.5 8 L 855.5 7 L 868.5 7 L 869.5 6 L 917.5 4 L 918.5 3 L 939.5 3 L 940.5 2 L 1013.5 1 L 1014.5 0 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_922"
          d="M 673 409 L 852 409 L 852 679.5 L 853 680.5 L 853 690.5 L 855 701.5 L 861 720.5 Q 870.2 742.8 887.5 757 Q 900.5 768 917.5 775 L 940.5 783 L 963.5 788 L 985.5 790 L 986.5 791 L 997.5 791 L 998.5 792 L 1016.5 792 L 1017.5 793 L 1079.5 793 L 1080.5 792 L 1097.5 791 L 1119.5 787 L 1157.5 776 Q 1188.1 765.6 1206 742.5 L 1219 721.5 L 1224 708.5 L 1228 689.5 L 1228 409 L 1405.5 409 L 1407 410.5 L 1432 475.5 L 1453 540.5 L 1470 603.5 L 1470 607.5 L 1478 638.5 L 1487 687.5 L 1496 719.5 Q 1508.3 754.2 1534.5 775 L 1642.5 852 L 1681 886.5 Q 1737.7 944.8 1774 1023.5 L 1788 1056.5 L 1804 1103.5 L 1815 1146.5 L 1821 1177.5 L 1824 1204.5 L 1825 1205.5 L 1825 1212.5 L 1826 1213.5 L 1826 1222.5 L 1827 1223.5 L 1828 1248.5 L 1829 1249.5 L 1829 1275.5 L 1830 1276.5 L 1830 1740.5 L 1829 1741.5 L 1828 1763.5 L 1825 1779.5 L 1816 1807.5 Q 1803.5 1837.5 1781.5 1858 Q 1768.6 1870.1 1751.5 1878 L 1743.5 1881 L 1723.5 1885 L 356.5 1885 L 339.5 1882 L 316.5 1872 Q 300.2 1861.8 288 1847.5 Q 271.7 1828.8 262 1803.5 L 255 1781.5 L 251 1759.5 L 251 1750.5 L 250 1749.5 L 250 1260.5 L 251 1259.5 L 251 1242.5 L 252 1241.5 L 252 1229.5 L 253 1228.5 L 255 1201.5 L 264 1149.5 L 279 1092.5 L 299 1038.5 Q 341.5 938.5 415.5 870 L 452.5 840 L 531.5 785 Q 548.4 772.9 562 757.5 Q 578.9 737.4 587 708.5 L 594 680.5 L 595 670.5 L 608 609.5 L 627 538.5 L 647 476.5 L 673 409 Z M 1014 945 L 1013 946 L 1001 946 L 1000 947 L 984 948 L 942 956 L 902 968 L 879 977 Q 814 1005 765 1049 Q 701 1105 663 1187 Q 646 1223 636 1266 L 629 1305 L 628 1322 L 627 1323 L 627 1336 L 626 1337 L 626 1381 L 627 1382 L 627 1395 L 628 1396 L 630 1420 L 639 1464 L 651 1502 Q 680 1579 731 1635 Q 788 1699 872 1737 L 902 1749 L 942 1761 L 984 1769 L 1000 1770 L 1001 1771 L 1013 1771 L 1014 1772 L 1063 1772 L 1064 1771 L 1077 1771 L 1078 1770 L 1094 1769 L 1133 1762 L 1175 1750 Q 1263 1718 1325 1659 Q 1381 1606 1416 1532 L 1432 1492 L 1442 1458 L 1451 1409 L 1452 1390 L 1453 1389 L 1453 1370 L 1454 1369 L 1453 1329 L 1452 1328 L 1451 1309 L 1450 1308 L 1450 1301 L 1447 1288 L 1447 1283 L 1438 1245 L 1427 1212 Q 1396 1134 1344 1078 Q 1285 1013 1199 976 L 1157 961 L 1115 951 L 1097 949 L 1096 948 L 1089 948 L 1088 947 L 1080 947 L 1079 946 L 1068 946 L 1067 945 L 1014 945 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_923"
          d="M 1034.5 1041 L 1052.5 1042 L 1065.5 1046 Q 1080.2 1052.8 1090 1064.5 Q 1097.9 1073.6 1102 1086.5 L 1104 1095.5 L 1104 1116.5 Q 1099 1141.5 1082.5 1155 Q 1074 1162.5 1062.5 1167 L 1051.5 1170 L 1035.5 1171 L 1034.5 1170 L 1023.5 1169 L 1006.5 1162 L 988 1145.5 L 977 1123.5 L 975 1113.5 L 975 1098.5 Q 980 1068.5 1000.5 1054 L 1016.5 1045 L 1034.5 1041 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_924"
          d="M 856.5 1115 L 866.5 1115 L 884.5 1119 Q 902.3 1126.3 913 1140.5 L 924 1162.5 L 926 1173.5 L 926 1186.5 L 924 1197.5 L 917 1213.5 Q 910.5 1224.5 900.5 1232 L 881.5 1242 L 873.5 1244 L 857.5 1245 L 856.5 1244 L 844.5 1243 L 833.5 1239 Q 820.8 1232.7 812 1222.5 Q 802.3 1211.7 798 1195.5 L 797 1190.5 L 797 1169.5 Q 802 1144.5 818.5 1131 L 833.5 1121 L 844.5 1117 L 855.5 1116 L 856.5 1115 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_925"
          d="M 1207.5 1116 L 1229.5 1116 L 1243.5 1120 Q 1259.7 1127.3 1270 1140.5 Q 1277.5 1149.5 1281 1162.5 L 1283 1171.5 L 1283 1188.5 L 1277 1208.5 Q 1270 1222 1258.5 1231 Q 1249.7 1238.2 1237.5 1242 L 1229.5 1244 L 1207.5 1244 Q 1183.5 1239 1170 1223.5 Q 1159.7 1212.3 1155 1195.5 L 1154 1190.5 L 1154 1169.5 Q 1159 1145.5 1174.5 1132 Q 1187 1120 1207.5 1116 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_926"
          d="M 1028.5 1245 L 1050.5 1245 Q 1052.3 1247.8 1058.5 1246 L 1085.5 1254 Q 1112.1 1265.9 1129 1287.5 Q 1142 1303.5 1149 1325.5 L 1153 1344.5 L 1153 1372.5 Q 1144.5 1422 1111.5 1447 Q 1095 1461 1071.5 1468 L 1051.5 1472 L 1028.5 1472 L 1011.5 1469 L 989.5 1461 Q 968.1 1449.9 953 1432.5 Q 937.7 1414.8 930 1389.5 L 926 1366.5 L 926 1350.5 L 930 1327.5 L 941 1301.5 Q 950.9 1284.4 965.5 1272 Q 978.8 1260.3 996.5 1253 L 1011.5 1248 L 1028.5 1245 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_927"
          d="M 778.5 1294 L 796.5 1294 L 811.5 1298 Q 827.8 1304.7 838 1317.5 Q 846 1327 850 1340.5 L 852 1349.5 L 852 1367.5 Q 846.8 1394.8 828.5 1409 Q 819 1417 805.5 1421 L 796.5 1423 L 778.5 1423 L 758.5 1417 Q 745 1410 736 1398.5 Q 727.7 1388.3 724 1373.5 L 723 1368.5 L 723 1348.5 Q 728.3 1320.8 747.5 1307 L 758.5 1300 L 778.5 1294 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_928"
          d="M 854.5 1472 L 867.5 1472 L 884.5 1476 Q 899.3 1481.7 909 1492.5 Q 919.4 1503.1 924 1519.5 L 926 1528.5 L 926 1544.5 Q 921 1573.5 901.5 1588 Q 886.6 1601.1 859.5 1602 L 858.5 1601 L 849.5 1601 L 836.5 1597 Q 822.2 1591.3 813 1580.5 Q 802.7 1569.3 798 1552.5 L 797 1547.5 L 797 1526.5 Q 802.3 1500.8 819.5 1487 L 835.5 1477 L 854.5 1472 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_929"
          d="M 1211.5 1472 L 1224.5 1472 L 1241.5 1476 Q 1259.3 1483.3 1270 1497.5 Q 1277.5 1506.5 1281 1519.5 L 1283 1529.5 L 1283 1544.5 Q 1278 1573.5 1258.5 1588 Q 1248.6 1596.1 1234.5 1600 L 1215.5 1602 L 1195.5 1598 Q 1179.3 1591.7 1169 1579.5 Q 1161.5 1571 1157 1559.5 L 1154 1548.5 L 1153 1534.5 L 1154 1533.5 L 1155 1520.5 L 1161 1505.5 Q 1167.5 1494 1177.5 1486 L 1192.5 1477 L 1211.5 1472 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_930"
          d="M 1033.5 1546 L 1046.5 1546 L 1065.5 1551 Q 1080.4 1557.6 1090 1569.5 Q 1098 1578.5 1102 1591.5 L 1104 1599.5 L 1104 1621.5 Q 1099 1646.5 1082.5 1660 Q 1073 1668.5 1059.5 1673 L 1051.5 1675 L 1028.5 1675 Q 1002.5 1669.5 989 1651.5 Q 981 1642 977 1628.5 L 975 1618.5 L 975 1603.5 L 977 1593.5 L 982 1580.5 Q 989.3 1567.8 1000.5 1559 L 1016.5 1550 L 1033.5 1546 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
      </g>
    </svg>

  </React.Fragment>
)

const icon = createSvgIcon(fragment, 'Phone')

export default icon
